import React, { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from 'antd'
import AdminLayout from './components/layout/AdminLayout'
import Dashboard from './pages/Dashboard'
import Games from './pages/Games'
import AddGames from './pages/AddGames'
import Categories from './pages/Categories'
import Tags from './pages/Tags'
import Users from './pages/Users'
import ImportLogs from './pages/ImportLogs'
import Login from './pages/Login'
import Setup from './pages/Setup'
import Help from './pages/Help'
import SettingsStorage from './pages/SettingsStorage'
import SettingsAds from './pages/SettingsAds'
import { useAuthStore } from './stores/authStore'
import { useSetupStatus } from './hooks/useSetupStatus'

const App: React.FC = () => {
  const { isAuthenticated, checkAuth } = useAuthStore()
  const { isComplete: isSetupComplete, isChecking: isCheckingSetup } = useSetupStatus()

  useEffect(() => {
    // Only check auth after setup status is determined
    if (isSetupComplete === true) {
      checkAuth()
    }
  }, [isSetupComplete, checkAuth])

  // Show loading while checking setup status
  if (isCheckingSetup) {
    return (
      <Layout style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div>Loading...</div>
      </Layout>
    )
  }

  // Show setup page if setup is not complete
  if (isSetupComplete === false) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Setup />
      </Layout>
    )
  }

  // If not authenticated, show login page
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  // If authenticated, show admin layout with protected routes
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AdminLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/games">
            <Route index element={<Games />} />
            <Route path="add" element={<AddGames />} />
            <Route path="upload" element={<Navigate to="/games/add?tab=upload" replace />} />
          </Route>
          <Route path="/categories" element={<Categories />} />
          <Route path="/tags" element={<Tags />} />
          <Route path="/users" element={<Users />} />
          <Route path="/import" element={<Navigate to="/games/add?tab=external" replace />} />
          <Route path="/import-logs" element={<ImportLogs />} />
          <Route path="/settings/storage" element={<SettingsStorage />} />
          <Route path="/settings/ads" element={<SettingsAds />} />
          <Route path="/help" element={<Help />} />
          <Route path="/login" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AdminLayout>
    </Layout>
  )
}

export default App
